module.exports = __webpack_public_path__ + "img/bp_button_normal_hccjcs.5e35314b.png";